package features.overtime.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onChangeFunction
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import shared.ui.ModalManager
import kotlinx.browser.document

object RequestOvertimeModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "request-overtime-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Request Overtime" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("space-y-4 mb-6") {
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Date" }
                        input(type = InputType.date, classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                            id = "overtime-date-input"
                            // Set max to today
                            val today = js("new Date().toISOString().split('T')[0]")
                            attributes["max"] = today.toString()
                            value = today.toString()
                        }
                    }
                    div("grid grid-cols-2 gap-4") {
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"Start Time" }
                            input(type = InputType.time, classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                id = "overtime-start-input"
                                onChangeFunction = { js("updateOvertimeHours")() }
                            }
                        }
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"End Time" }
                            input(type = InputType.time, classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                id = "overtime-end-input"
                                onChangeFunction = { js("updateOvertimeHours")() }
                            }
                        }
                    }
                    // Auto-calculated hours display
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Total Hours" }
                        div("w-full bg-dark-900 border border-dark-700 rounded-xl p-3 text-white font-bold text-lg") {
                            id = "overtime-hours-display"
                            +"0.0h"
                        }
                    }
                    div {
                        label("block text-sm text-slate-400 mb-1") { 
                            +"Reason "
                            span("text-xs text-slate-500") { +"(minimum 10 characters)" }
                        }
                        textArea(classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white resize-none h-24") {
                            id = "overtime-reason-input"
                            placeholder = "Reason for overtime (e.g., urgent project deadline, system maintenance)..."
                        }
                    }
                }
                
                button(classes = "w-full py-3 rounded-xl bg-brand-cyan text-white font-bold hover:bg-brand-green transition") {
                    onClickFunction = { js("submitOvertime")() }
                    +"Submit Request"
                }
            }
        }
    }
}
